import { FilledChevron } from 'src/components/Icons/FilledChevron'

type CarouselNavButtonsProps = {
  onPrevClick: () => void
  onNextClick: () => void
  navState: {
    prev: boolean
    next: boolean
  }
}

const CarouselNavButtons = ({
  onNextClick,
  onPrevClick,
  navState,
}: CarouselNavButtonsProps) => {
  return (
    <div className="flex gap-6">
      <button
        type="button"
        aria-label="Item anterior"
        className="shelf-v2-controlButton flex items-center justify-center w-12 h-12 rounded-round border border-neutral04 disabled:cursor-not-allowed"
        onClick={onPrevClick}
        disabled={!navState.prev}
      >
        <FilledChevron direction="left" disabled={!navState.prev} />
      </button>
      <button
        type="button"
        aria-label="Próximo item"
        className="shelf-v2-controlButton flex items-center justify-center w-12 h-12 rounded-round border border-neutral04 disabled:cursor-not-allowed"
        onClick={onNextClick}
        disabled={!navState.next}
      >
        <FilledChevron disabled={!navState.next} />
      </button>
    </div>
  )
}

export default CarouselNavButtons
